import PropTypes from 'prop-types';
import React from 'react';
import Autocomplete from '../utils/Autocomplete';


class PubSelect extends React.Component {

  state = {
    firstTime: [],
  };

  handleSelect = selected => {
    // console.log('handleSelect', selected);
    const evt = {
      target: { name: 'Pubs', value: selected }
    }
    this.props.onChange(evt);
  };

  render() {
    const { currentPubs, selectType, constants, disabled, pubsCleared, isNew } = this.props;
    const label = (selectType === 'CUSTOM') ? 'Publishers' : `${selectType} Publishers`;
    let allPubs = [];
    let keepOpen = false;
    if (selectType === 'CUSTOM' || selectType === 'AURA') {
      keepOpen = true;
      allPubs = constants.pubsHOO;
      const allHearst = allPubs.find(p => p.name === 'All Hearst Autos');
      if (!allHearst) {
        allPubs.push({ name: 'All Hearst Autos' });
      }
    } else if (selectType === 'N_ROS') {
      keepOpen = true;
      allPubs = constants.pubsHOO;
      allPubs.push({ name: 'Hot Rod' })
      const allHearst = allPubs.find(p => p.name === 'All Hearst Autos');
      if (!allHearst) {
        allPubs.push({ name: 'All Hearst Autos' });
      }
    } else if (selectType === 'AURA_TV') {
      allPubs = constants.pubsHDM;
    } else if (selectType === 'HDM') {
      allPubs = constants.pubsHDM;
    } else if (selectType === 'CDRT') {
      allPubs = constants.pubsCDRT;
    } else if (selectType === 'YT_HDM') {
      allPubs = constants.pubsYT_HDM;
    } else if (selectType === 'YT_CDRT') {
      allPubs = constants.pubsYT_CDRT;
    } else if (selectType === 'HOO') {
      allPubs = constants.pubsHOO;
    } else {
      return false;
    }
    let pubs = [];
    if (currentPubs && currentPubs.length > 0) {
      if (selectType !== 'CUSTOM') {
        pubs = currentPubs.filter(cp => cp.name !== 'All Hearst Autos');
      } else {
        pubs = currentPubs;
      }
    }
    const allPubNames = allPubs.map(p => p.name);
    if (selectType === 'AURA_TV') {
      if (isNew && this.state.firstTime) {
        pubs = allPubs;
        this.setState({ firstTime: false})
        this.handleSelect(pubs);
      }
    } else if (!pubsCleared) {
      if (selectType !== 'YT_HDM' && selectType !== 'YT_CDRT' &&
        selectType !== 'CUSTOM' && selectType !== 'AURA' && selectType !== 'N_ROS' &&
        (pubs.length === 0 || (pubs.length > 0 && !allPubNames.includes(pubs[0].name)))) {
        pubs = allPubs;
        this.handleSelect(pubs);
      }
    }
    return (
      <Autocomplete
        disabled={disabled}
        onChange={this.handleSelect}
        value={pubs}
        suggestions={allPubs}
        name="Pubs"
        suggestionKey="name"
        label={label}
        keepOpen={keepOpen}
        pubsCleared={pubsCleared}
        placeholder="Select or start typing"
      />
    );
  }
}

PubSelect.defaultProps = {
  currentPubs: []
};

PubSelect.propTypes = {
  currentPubs: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  selectType: PropTypes.string.isRequired,
  constants: PropTypes.object.isRequired
};

export default PubSelect;
